export const API_ENDPOINTS = {
  LOGIN: '/ums/api/staff/login',
  LOGOUT: '/ums/api/staff/logout',
  REGISTER: '/ums/api/staff/register',
  REFRESH_TOKEN: '/ums/api/staff/refresh-token',
  GET_PLAN_LIST: '/ums/api/packages',
  GET_PAYMENT_LIST: '/ums/api/payment/list',
  GET_BANKING_LIST: '/ums/api/banks',
  GET_BENEFICIARY_ACCOUNTS_LIST: '/ums/api/beneficiary-accounts',
  GET_BENEFICIARY_ACCOUNT_DETAIL: (id: string) => `/ums/api/beneficiary-accounts/${id}`,
  ADD_NEW_BENEFICIARY_ACCOUNT: '/ums/api/beneficiary-accounts',
  UPDATE_BENEFICIARY_ACCOUNT: (id: number) => `/ums/api/beneficiary-accounts/${id}`,
  DELETE_BENEFICIARY_ACCOUNT: (id: number) => `/ums/api/beneficiary-accounts/${id}`,

  DELETE_DEVICE: '/users/delete-device',

  GET_PROXY_LIST: '/service/api/ra/proxy/list',
  ADD_PROXY: '/service/api/ra/proxy/add',
  DETAIL_PROXY: '/service/api/ra/proxy',
  UPDATE_PROXY: '/service/api/ra/proxy/update',
  GET_HISTORY_ACTIVITY_PROXY: '/service/api/ra/proxy/list-activity',
  DELETE_PROXY: (id: number) => `/service/api/ra/proxy/delete/${id}`,
  CHECK_PROXY_HEALTH: (id: number) => `/service/api/ra/proxy/check/${id}`,
  CHECK_DELETE_PROXY: (id: number) => `/service/api/ra/proxy/delete-check/${id}`,

  GET_NOTIFICATION_TOPIC: '/service/api/notification/topic/list',
  SEND_NOTIFICATION: '/service/api/notification/send',

  // Organization Management APIs
  GET_ORGANIZATIONS_LIST: '/service/api/ra/organizations',
  GET_ORGANIZATION_DETAIL: '/service/api/ra/organizations',
  GET_ORGANIZATION_USERS: '/service/api/ra/organizations/:domain/users',
  GET_ORGANIZATION_ZALO_ACCOUNTS: '/service/api/ra/organizations/:domain/zalo-accounts',
  UPDATE_ORGANIZATION: '/service/api/ra/organizations/:domain',
  DELETE_ORGANIZATION: '/service/api/ra/organizations/delete/:domain',
  GET_ORGANIZATION_RESOURCE_USAGE: (domain: string) => `/service/api/ra/organizations/${domain}/resource-usage`,
  GET_ORGANIZATION_SETTINGS: (domain: string) => `/service/api/ra/organizations/${domain}/settings`,
  UPDATE_ORGANIZATION_SETTINGS: (domain: string) => `/service/api/ra/organizations/${domain}/settings`,
  GET_ORGANIZATION_ALLOWED_PROXIES: (domain: string) => `/service/api/ra/organizations/${domain}/allowed-proxies`,
  UPDATE_ORGANIZATION_ALLOWED_PROXIES: (domain: string) => `/service/api/ra/organizations/${domain}/allowed-proxies`,

  // Storage Statistics APIs
  GET_GLOBAL_STORAGE_STATS: '/service/api/ra/stats/global',
  GET_ORGANIZATION_STORAGE_STATS: '/service/api/ra/stats/organization',
  GET_ZALO_STORAGE_STATS: '/service/api/ra/stats/zalo',

  // Subscription Management APIs
  GET_SUBSCRIPTION_LIST: '/ums/api/subscriptions',
  ADD_SUBSCRIPTION: '/ums/api/subscriptions',
  EXTEND_SUBSCRIPTION: '/ums/api/subscriptions/extend',
  CANCEL_SUBSCRIPTION: '/ums/api/subscriptions/cancel',
  GET_TOTAL_USAGE: (domain: string) => `/ums/api/subscriptions/${domain}/total-usage`,

  // User Management APIs
  UPDATE_USERS_STATUS: '/service/api/ra/organization-member/change-status',
  GET_USER_STATUS_COUNTS: (domain: string) => `/service/api/ra/organization-member/status-counts/${domain}`,
  BULK_ACTIVATE_USERS: (domain: string) => `/service/api/ra/organization-member/bulk-activate/${domain}`,
  BULK_DEACTIVATE_USERS: (domain: string) => `/service/api/ra/organization-member/bulk-deactivate/${domain}`,

  // Staff Management APIs
  GET_STAFF_LIST: '/ums/api/staff/list',
  GET_STAFF_DETAIL: (id: string) => `/ums/api/staff/${id}`,
  ADD_STAFF: '/ums/api/staff/register',
  UPDATE_STAFF: (id: string) => `/ums/api/staff/${id}`,
  DELETE_STAFF: (id: string) => `/ums/api/staff/${id}`,
  CHANGE_STAFF_PASSWORD: (id: string) => `/ums/api/staff/${id}/change-password`,
  CHANGE_USER_PASSWORD: '/ums/api/staff/change-user-password',
};
